<template>
  <div id="group-edit-page" class="py-5" role="tabpanel" aria-labelledby="groupEdit">
    <h2 class="pb-3 text-center">Edit Group</h2>
    <div class="row no-gutters">
      <div class="col-12 col-lg-6 pr-lg-2">
        <div class="row no-gutters">
          <div class="col-12 mb-2">
            <edit-display-properties response-name="updateDisplayPropsResponse"
                                     :managed-group="managedGroup">
            </edit-display-properties>
          </div>
        </div>
        <div class="row no-gutters">
          <div class="col-12 mb-2">
            <edit-role-type
              :managed-group="managedGroup"
              :role-kinds="['person']"
              role-type="contacts"
              response-name="updateContactsResponse" />
          </div>
        </div>
        <div class="row no-gutters">
          <div class="col-12 mt-2">
            <edit-role-type
              :managed-group="managedGroup"
              :role-kinds="['service']"
              role-type="viewers"
              response-name="updateViewersResponse" />
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6 pl-lg-2">
        <div class="row no-gutters">
          <div class="col-12 mb-2">
            <edit-role-type
              :managed-group="managedGroup"
              :role-kinds="['person', 'service']"
              role-type="administrators"
              response-name="updateAdministratorsResponse" />
          </div>
        </div>
        <div class="row no-gutters">
          <div class="col-12 mt-2">
            <edit-role-type
              :managed-group="managedGroup"
              :role-kinds="['person', 'service']"
              role-type="managers"
              response-name="updateManagersResponse" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EditDisplayProperties from './EditDisplayProperties';
import EditRoleType from './EditRoleType';

export default {
  name: 'EditGroup',
  props: {
    managedGroup: {
      type: Object,
      required: true,
    },
  },
  components: {
    EditDisplayProperties,
    EditRoleType,
  },
  data() {
    return {
      pipelineResponses: [
        { responseName: 'updateContactsResponse' },
        { responseName: 'updateAdministratorsResponse' },
        { responseName: 'updateManagersResponse' },
        { responseName: 'updateDisplayPropsResponse' },
      ],
    };
  },
  methods: {
    clearPipelineResponses() {
      const vm = this;
      /* Clear the pipelined requests state for each card on this page. */
      this.pipelineResponses.forEach((response) => {
        vm.$store.dispatch('clearPipelinedStateResponse', response.responseName)
          .then(() => 'done');
      });
    },
    track() {
      this.$gtag.pageview({
        page_title: 'Edit Group',
        page_path: `/group/${this.managedGroup.uugid}`,
      });
    },
  },
  activated() {
    this.clearPipelineResponses();
    this.track();
  },
  deactivated() {
    this.clearPipelineResponses();
  },
};
</script>

<style scoped>
  /* Override bootstrap-vue styles for card elements */
  /*noinspection CssUnusedSymbol*/
  .card {
    padding-bottom: .75em;
  }
</style>



// WEBPACK FOOTER //
// src/components/edit-group/EditGroup.vue